import React, { useEffect, useState } from 'react'

import { Box, CircularProgress } from '@mui/material'

import Dialog from '~/src/Dialog'

const Component = () => {
  const [show, setShow] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true)
    }, 800)
    return () => clearTimeout(timer)
  }, [])

  return show ? (
    <Dialog fullWidth open maxWidth="sm">
      <Box className="center-all" width="100%" sx={{ '&.center-all': { height: '20rem' } }}>
        <CircularProgress size={100} />
      </Box>
    </Dialog>
  ) : null
}

export default Component
